module.exports = __webpack_public_path__ + "static/media/Neon.0234f389.mp3";